import { isFunction } from 'lodash/fp';
import {
    CREATE_EVENT_SUBSCRIPTION_OPERATION,
    DELETE_EVENT_SUBSCRIPTION_OPERATION,
    UNINSTALL_SLACK_OPERATION,
    UPDATE_EVENT_SUBSCRIPTION_DELIVERY_TARGET_OPERATION,
    GET_EVENT_SUBSCRIPTION_OPERATION,
    GET_SLACK_AUTHORIZATION_URL_OPERATION,
    LIST_SLACK_CHANNELS_OPERATION,
    CREATE_SLACK_CHANNEL_OPERATION
} from 'app/store/__generated__/operations';
import { SLACK_CHANNEL_TYPE } from 'app/store/__generated__/types';
import { selectProjectUid } from 'app/store/projects/selectors.js';
import { selectEventSubscription } from 'app/store/integrations/slack/selectors.js';
import {
    GET_SLACK_AUTHORIZATION,
    GET_SLACK_AUTHORIZATION_URL,
    UNINSTALL_SLACK,
    LIST_SLACK_CHANNELS,
    CREATE_SLACK_CHANNEL,
    CREATE_EVENT_SUBSCRIPTION,
    DELETE_EVENT_SUBSCRIPTION,
    GET_EVENT_SUBSCRIPTION,
    UPDATE_EVENT_SUBSCRIPTION_DELIVERY_TARGET,
    UPDATE_CHANNEL
} from './types.js';

function buildEventName(projectUid) {
    const id = projectUid.match(/_s(\d+)/)[1];
    return `europa.project[${id}].output`;
}

export const doGetSlackAuthorization = () => ({
    type: GET_SLACK_AUTHORIZATION,
    api: { version: 2, name: 'GetSlackConfiguration' }
});

export const doGetSlackUrl = ({ refererPath }) => ({
    type: GET_SLACK_AUTHORIZATION_URL,
    api: GET_SLACK_AUTHORIZATION_URL_OPERATION,
    params: { refererPath },
    onSucceeded: ({ data }) => {
        const { url } = data;
        window.location.href = url;
    }
});

export const doUninstallSlack = () => ({
    type: UNINSTALL_SLACK,
    api: UNINSTALL_SLACK_OPERATION,
    onSucceeded: ({ dispatch }) => {
        dispatch(doGetSlackAuthorization());
    },
    onFailed: ({ dispatch }) => {
        dispatch(doGetSlackAuthorization());
    }
});

export const doListSlackChannels = () => ({
    type: LIST_SLACK_CHANNELS,
    api: LIST_SLACK_CHANNELS_OPERATION
});

export const doLoadEventSubscription = () => ({
    type: GET_EVENT_SUBSCRIPTION,
    api: GET_EVENT_SUBSCRIPTION_OPERATION,
    params: (state) => {
        const projectUid = selectProjectUid(state);
        return { name: buildEventName(projectUid) };
    }
});

const doUpdateSubscriptionChannel = (eventName, channelId) => ({
    type: UPDATE_EVENT_SUBSCRIPTION_DELIVERY_TARGET,
    api: UPDATE_EVENT_SUBSCRIPTION_DELIVERY_TARGET_OPERATION,
    params: {
        name: eventName,
        newDeliveryTarget: {
            _type: SLACK_CHANNEL_TYPE,
            id: channelId
        }
    },
    onSucceeded: ({ dispatch }) => {
        dispatch(doLoadEventSubscription());
    }
});

export const doCreateSlackChannel = (name, callback) => ({
    type: CREATE_SLACK_CHANNEL,
    api: CREATE_SLACK_CHANNEL_OPERATION,
    params: { name },
    onSucceeded: ({ dispatch, data }) => {
        if (isFunction(callback)) {
            callback(data.id);
        }
        dispatch(doListSlackChannels());
    }
});

const doSubscribeProject = (projectUid, channelId) => ({
    type: CREATE_EVENT_SUBSCRIPTION,
    api: CREATE_EVENT_SUBSCRIPTION_OPERATION,
    params: {
        target: {
            _type: SLACK_CHANNEL_TYPE,
            id: channelId
        },
        eventFilters: {
            projectUid
        },
        eventId: 'europa.space.publish.ProjectOutputEvent',
        name: buildEventName(projectUid)
    },
    onSucceeded: ({ dispatch }) => {
        dispatch(doLoadEventSubscription());
    }
});

export const doUnsubscribeProject = (projectUid) => ({
    type: DELETE_EVENT_SUBSCRIPTION,
    api: DELETE_EVENT_SUBSCRIPTION_OPERATION,
    params: { name: buildEventName(projectUid) },
    onSucceeded: ({ dispatch }) => {
        dispatch(doLoadEventSubscription());
    }
});

export const doUpdateSlackChannel = (projectUid, channelId) => ({
    type: UPDATE_CHANNEL,
    effect: ({ store }) => {
        const state = store.getState();
        const eventSubscription = selectEventSubscription(state);
        if (eventSubscription !== null) {
            const projectUid = selectProjectUid(state);
            const eventName = buildEventName(projectUid);
            store.dispatch(doUpdateSubscriptionChannel(eventName, channelId));
        } else {
            store.dispatch(doSubscribeProject(projectUid, channelId));
        }
    }
});
